import React, { PureComponent } from 'react'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { connect } from 'react-redux'
import pure from 'recompose/pure'
import NavigationButton, { BUTTON_TYPES } from './components/navigationButton'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import { nextPoint, prevPoint, setTrail, pointTurn } from 'aria-viewer/tour/tourActions'

import {
    setWalkingDirection,
    setEntryPoint,
    ENTRY_POINT_BEFORE,
    ENTRY_POINT_AFTER,
    FORWARD,
    FRONT,
} from './navigationActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import componentFader from 'aria-viewer/utils/componentFader'

import { MEDIA_TYPES, NAV_BUTTON_TYPES } from 'aria-viewer/tour/constants'
import Browser from 'aria-viewer/utils/mobileDetect'
import { setStopInitiatedBy } from 'aria-viewer/analytics/analyticActions'
import { STOP_ANALYTICS_INITIATED_BY } from 'aria-viewer/tour/constants/'

const baseNav = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
}
const B = Object.assign({}, baseNav, {
    bottom: '0',
})

const style = {
    arrow: {
        F: Object.assign({}, baseNav, {}),
        F_B: Object.assign({}, baseNav, {
            transform: 'translateX(-58%)',
        }),
        F_L: Object.assign({}, baseNav, {
            transform: 'translateX(-68%)',
        }),
        F_R: Object.assign({}, baseNav, {
            transform: 'translateX(-30%)',
        }),
        F_BL: Object.assign({}, baseNav, {
            transform: 'translateX(-77%)',
        }),
        F_BR: Object.assign({}, baseNav, {
            transform: 'translateX(-23%)',
        }),
        B: B,
        B_F: B,
        B_L: B,
        B_R: B,
        B_BL: B,
        B_BR: B,
        L: Object.assign({}, baseNav, {
            top: '30%',
            transform: 'translateX(-75%)',
        }),
        R: Object.assign({}, baseNav, {
            top: '30%',
            transform: 'translateX(-24%)',
        }),
    },
    hint: {
        LEFT: {
            position: 'absolute',
            bottom: '70%',
            display: 'inline-block',
            left: '0',
        },
        RIGHT: {
            position: 'absolute',
            bottom: '70%',
            display: 'inline-block',
            right: '0',
        },
        FRONT: {
            position: 'absolute',
            display: 'inline-block',
        },
    },
    frontHint: {
        height: 50,
        padding: '0 10px',
        left: '50%',
        transform: 'translateX(-50%)',
    },
    look: {
        LEFT: {
            position: 'absolute',
            bottom: '35vh',
            right: '22.5vw',
        },
        RIGHT: {
            position: 'absolute',
            bottom: '35vh',
            left: '22.5vw',
        },
    },
}

const BtnStyle = {
    arrow: {
        F: Object.assign({}, baseNav, {}),
        F_B: Object.assign({}, baseNav, {
            transform: 'translateX(-58%)',
        }),
        F_L: Object.assign({}, baseNav, {
            transform: 'translateX(-68%)',
        }),
        F_R: Object.assign({}, baseNav, {
            transform: 'translateX(-30%)',
        }),
        F_BL: Object.assign({}, baseNav, {
            transform: 'translateX(-77%)',
        }),
        F_BR: Object.assign({}, baseNav, {
            transform: 'translateX(-23%)',
        }),
        B: B,
        B_F: B,
        B_L: B,
        B_R: B,
        B_BL: B,
        B_BR: B,
        L: Object.assign({}, baseNav, {
            top: '30%',
            transform: 'translateX(-75%)',
        }),
        R: Object.assign({}, baseNav, {
            top: '30%',
            transform: 'translateX(-24%)',
        }),
    },
    hint: {
        LEFT: {
            position: 'absolute',
            bottom: '70%',
            display: 'inline-block',
            left: '0',
        },
        RIGHT: {
            position: 'absolute',
            bottom: '70%',
            display: 'inline-block',
            right: '0',
        },
        FRONT: {
            position: 'absolute',
            display: 'inline-block',
        },
    },
    look: {
        LEFT: {
            position: 'absolute',
            bottom: '35vh',
            right: '22.5vw',
        },
        RIGHT: {
            position: 'absolute',
            bottom: '35vh',
            left: '22.5vw',
        },
    },
}

const getHintButtonStyle = function({ total, type, direction, isHint, style }) {
    return isHint && total > 1 ? MultiButtonLayout[type][direction] || style : style
}

const MultiButtonLayout = {
    hint: {
        FRONT: Object.assign({}, BtnStyle.hint.FRONT, {
            position: 'absolute',
            bottom: '',
            top: 0,
        }),
        B: {
            position: 'absolute',
            bottom: 0,
            transform: 'translateX(-50%) scale(.8)',
        },
    },
}

const isPhone = Browser.phone()

const NavigationButtons = pure(function NavigationButtons({
    navButtons,
    navigation,
    sizes,
    stopIndex,
    stopsList,
    onClick,
}) {
    const { type, walkingDirection } = navButtons[0] || {}
    const singleHintButton = navButtons.length <= 1 && type === NAV_BUTTON_TYPES.HINT && walkingDirection === FORWARD
    const prepend =
        !Browser.phone() &&
        type == NAV_BUTTON_TYPES.HINT &&
        navigation.get('orientation') == FRONT &&
        stopsList.length - 1 != stopIndex
            ? 'Next: '
            : ''

    return (
        <div>
            {navButtons.map((btn, index) => {
                const isHint = btn.type == NAV_BUTTON_TYPES.HINT,
                    totalHints = navButtons.filter(btn => btn.type == NAV_BUTTON_TYPES.HINT).length,
                    prependText = isHint && totalHints > 1 && !isPhone && btn.direction != FRONT ? '' : prepend

                return (
                    <NavigationButton
                        onClick={onClick}
                        style={Object.assign(
                            {},
                            //Desktop will be taking on a different style for hints
                            isHint && !isPhone ? style.frontHint : {},
                            //If we have more than one hint we need a custom layout
                            getHintButtonStyle({
                                total: totalHints,
                                type: btn.type,
                                style: BtnStyle[btn.type][btn.direction],
                                direction: btn.direction,
                                isHint,
                            }),
                            //if we have less than two hints on desktop we need to fix the positioning
                            isHint && totalHints < 2 && !isPhone ? { bottom: '45%' } : {}
                        )}
                        key={index}
                        type={btn.type}
                        actionName={btn.actionName}
                        direction={btn.direction}
                        orientation={btn.orientation}
                        trail={btn.trail}
                        title={`${prepend}${btn.title}`}
                        walkingDirection={btn.walkingDirection}
                        mainMediaType={btn.mainMediaType}
                        singleHintButton={singleHintButton}
                        sizes={sizes}
                        navigation={navigation}
                        lookThumb={btn.lookThumb}
                    />
                )
            })}
        </div>
    )
})

const FadingNavigationButtons = componentFader(NavigationButtons)

class Navigation extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            isShown: false,
            isFadingButton: false,
            wasFadingButton: false,
        }
    }

    getNavAction = (e, { actionName, trail, orientation, walkingDirection, mainMediaType }) => {
        const {
            nextPoint,
            prevPoint,
            pointTurn,
            setTrail,
            setWalkingDirection,
            setEntryPoint,
            setStopInitiatedBy,
        } = this.props

        const initiatedBy =
            e.type == 'keydown' ? STOP_ANALYTICS_INITIATED_BY.keyboard : STOP_ANALYTICS_INITIATED_BY.nav_button
        setStopInitiatedBy(initiatedBy)

        switch (actionName) {
            case 'nextPoint':
                return nextPoint()
            case 'prevPoint':
                return prevPoint()
            case 'faceDirection':
                return pointTurn(orientation)
            case 'gotoTrailFirstPoint':
                return setTrail(trail)
            case 'gotoTrailLastPoint':
                return setTrail(trail, true)
            case 'nextCoord':
            case 'prevCoord':
                const isForwardDirection = walkingDirection == FORWARD

                setEntryPoint(isForwardDirection ? ENTRY_POINT_BEFORE : ENTRY_POINT_AFTER)

                if (mainMediaType != MEDIA_TYPES.panorama) {
                    if (isForwardDirection) {
                        return nextPoint()
                    } else {
                        return prevPoint()
                    }
                } else {
                    return setWalkingDirection(walkingDirection)
                }
        }
    }
    componentWillReceiveProps(newProps) {
        this.receiveNewProps(newProps)
    }
    componentDidMount() {
        this.receiveNewProps(this.props)
    }
    receiveNewProps = newProps => {
        const wasFadingButton = typeof this.state.isFadingButton == 'undefined' ? undefined : this.state.isFadingButton

        const navButton = newProps.navButtons[0] || {}
        const { type: newType, mainMediaType: newMainMediaType } = navButton

        this.isFadingButton =
            newType === NAV_BUTTON_TYPES.HINT &&
            (newMainMediaType === MEDIA_TYPES.video || newMainMediaType === MEDIA_TYPES.panorama)

        this.setState({
            isShown: this.calculateIsShown(newProps),
            isFadingButton: this.isFadingButton,
            wasFadingButton: wasFadingButton,
        })
    }

    calculateIsShown = props => {
        const {
            tourHintButton,
            isPanoUIVisible,
            isVideoUIVisible,
            altMainMedia,
            skippedAltMainMedia,
            stopsList,
            stopIndex,
        } = props
        const navButton = props.navButtons[0] || {}
        const { mainMediaType } = navButton

        //  don't want navigation for personalized stops
        if (stopsList?.get(stopIndex)?.isPersonalized) return false

        let shouldShowButtons = true

        switch (mainMediaType) {
            case MEDIA_TYPES.video:
                shouldShowButtons = mainMediaType == MEDIA_TYPES.video && isVideoUIVisible
                break
            case MEDIA_TYPES.panorama:
                shouldShowButtons = mainMediaType == MEDIA_TYPES.panorama && isPanoUIVisible
                break
            default:
                shouldShowButtons = true // if not pano/video, just show the UI
                break
        }

        if (altMainMedia) {
            shouldShowButtons = shouldShowButtons && skippedAltMainMedia
        }

        return shouldShowButtons
    }

    render() {
        const { navButtons, style, stopsList, stopIndex, sizes, navigation } = this.props

        const navButton = navButtons[0] || {}
        const { type } = navButton

        // only if we are now fading but before we werent should
        // we fade; otherwise looks a bit jerky
        const shouldFade = this.state.isFadingButton && !this.state.wasFadingButton

        return (
            <div style={style}>
                {shouldFade ? (
                    <FadingNavigationButtons
                        onClick={this.getNavAction}
                        navButtons={navButtons}
                        sizes={sizes}
                        stopIndex={stopIndex}
                        stopsList={stopsList}
                        type={type}
                        navigation={navigation}
                        isShown={this.state.isShown}
                    />
                ) : (
                    this.state.isShown && (
                        <NavigationButtons
                            onClick={this.getNavAction}
                            navButtons={navButtons}
                            sizes={sizes}
                            stopIndex={stopIndex}
                            stopsList={stopsList}
                            type={type}
                            navigation={navigation}
                        />
                    )
                )}
            </div>
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'navButtons',
        'isPanoUIVisible',
        'isVideoUIVisible',
        'mainMediaInitialized',
        'tourHintButton',
        'navigation',
        'altMainMedia',
        'skippedAltMainMedia',
        'stopIndex',
        'stopsList',
    ]),
    {
        nextPoint,
        prevPoint,
        setTrail,
        pointTurn,
        setWalkingDirection,
        setEntryPoint,
        setStopInitiatedBy,
    }
)(Navigation)
